import { render, staticRenderFns } from "./Capricorn.vue?vue&type=template&id=1a66ab92&"
import script from "./Capricorn.vue?vue&type=script&lang=js&"
export * from "./Capricorn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports